import { createWebHistory, createRouter } from 'vue-router'
import DashboardIem from "@/components/Dashboard";
import LoginItem from "@/components/Login";
import SensorReportingItem from "@/components/Sensor/SensorReportingItem";
import AlertItem from "@/components/alert/AlertItem";
import ReportsItem from "@/components/reports/ReportsItem";
import SettingItem from "@/components/profile/SettingItem";
import ReceivedAlerts from "@/components/alert/ReceivedAlerts";


const routes = [
    {
        path: '/',
        name: 'dashboard',
        component: DashboardIem
    },
    {
        path: '/login',
        component: LoginItem
    },
    {
        path:'/alerts',
        component: AlertItem
    },
    {
        path:'/reports',
        component: ReportsItem
    },
    {
        path: '/sensor/reports/:id',
        component: SensorReportingItem
    },
    {
        path: '/settings',
        component: SettingItem
    },
    {
        path: '/received-alerts',
        component: ReceivedAlerts
    },

]

const router = createRouter({
    linkActiveClass: "active",
    history: createWebHistory(),
    routes
})

router.beforeEach((to,from,next) => {
    const publicPages = ['/login','/register']
    const authRequired = !publicPages.includes(to.path)
    const loggedIn = localStorage.getItem('user')

    if (authRequired && !loggedIn) {
        next('/login')
    }else{
        next()
    }
})

export default router;